import { translateText } from './translator';

let isIntlTelInputLoaded = false;

// Fetch user's country based on IP
async function fetchCountryCode() {
  try {
    let endpoint = '/api/method/zoni_edu.controller.get_country_from_ip';
    if (window.location.host === 'highschool.zoni.edu') {
      endpoint = 'https://www.zoni.edu' + endpoint;
    }
    const resp = await fetch(endpoint, {
      headers: { 'Content-Type': 'application/json' }
    });
    const data = await resp.json();
    let countryCode = data.message;
    if (countryCode === 'Local' || countryCode === 'Unknown') {
      countryCode = 'US';
    }
    return countryCode.toLowerCase();
  } catch (err) {
    console.error('Error fetching country based on IP:', err);
    return 'us';
  }
}

// Generic validity checker
async function updateValidity(itiInstance, errorSelector, submitBtnSelector = "button[id='zoniModalSubmitButton']", selector = null) {
  if (itiInstance.isValidNumber()) {
    document.querySelector(errorSelector).style.display = 'none';
    if (submitBtnSelector) {
      document.querySelector(submitBtnSelector).disabled = false;
    }
    if (selector) {
      const input = document.querySelector(selector);
      if (input) {
        input.setCustomValidity("");
        input.classList.remove("is-invalid");
      }
    }
  } else {
    const msg = await translateText('Please enter a valid phone number for the selected country.');
    const el = document.querySelector(errorSelector);
    el.textContent = msg;
    el.style.display = 'block';
    if (submitBtnSelector) {
      document.querySelector(submitBtnSelector).disabled = true;
    }
  }
}

// Initialize an intl-tel-input on a given selector
export async function initIntlPhone({
  selector,
  instanceKey,
  errorSelector = null,
  submitBtnSelector = null,
  preferred = ['us']
}) {
  const input = document.querySelector(selector);
  if (!input) {
    console.error(`Input element ${selector} not found.`);
    return;
  }

  const countryCode = await fetchCountryCode();
  const preferredCountries = Array.from(new Set([...preferred, countryCode]));

  const host = window.location.origin;
  const iti = window.intlTelInput(input, {
    initialCountry: 'us',
    loadUtils: () => import(`${host}/assets/zoni_edu/node_modules/intl-tel-input/build/js/utils.js`),
    formatOnDisplay: true,
    separateDialCode: true,
    preferredCountries
  });

  // Store globally
  window[instanceKey] = iti;

  // Mark loaded
  if (instanceKey === 'iti') {
    isIntlTelInputLoaded = true;
  }

  // Common event bindings
  ['input', 'blur', 'countrychange'].forEach(evt => {
    input.addEventListener(evt, () => {
      if (errorSelector) updateValidity(iti, errorSelector, submitBtnSelector, selector);
    });
  });

  // Set the detected country
  try {
    iti.setCountry(countryCode);
  } catch (e) {
    console.warn('Could not set country on intlTelInput:', e);
  }
}

// get the phone number from the intl-tel-input instance
export function getPhoneNumber(instanceKey) {
  const iti = window[instanceKey];
  if (iti && iti.isValidNumber()) {
    return iti.getNumber();
  } else {
    return '';
  }
}

// Check if the phone number from the intl-tel-input instance is valid
export function isPhoneNumberValid(instanceKey) {
  const iti = window[instanceKey];
  if (iti) {
    return iti.isValidNumber();
  } else {
    console.warn(`IntlTelInput instance ${instanceKey} is not initialized.`);
    return false;
  }
}

export function getIntlTelInputLoadedStatus() {
  return isIntlTelInputLoaded;
}

export function setIntlTelInputLoadedStatus(status) {
  isIntlTelInputLoaded = status;
}

// Convenience wrappers
export function loadAndInitializeIntlTelInput() {
  return initIntlPhone({
    selector: '#intl_phone_id',
    instanceKey: 'iti',
    errorSelector: '#phone-error',
    submitBtnSelector: "button[id='zoniModalSubmitButton']"
  });
}

export function loadAndInitializeIntlTelApplicationInput(selector = '#student_phone_number') {
  return initIntlPhone({
    selector,
    instanceKey: 'itiApplication',
    errorSelector: '#phone-error-application'
  });
}

export function loadAndInitializeIntlTelGuardianInput(selector = '#guardian_phone_number') {
  return initIntlPhone({
    selector,
    instanceKey: 'itiGuardian',
    errorSelector: '#phone-error-guardian'
  });
}

export function loadAndInitializeIntlTelGuardian2Input(selector = '#guardian2_phone_number') {
  return initIntlPhone({
    selector,
    instanceKey: 'itiGuardian2',
    errorSelector: '#phone-error-guardian2'
  });
}
